import React from 'react';
import { View, Text } from 'react-native';
import styles from '../styles';

const LedgerLine = ({
  title,
  label,
  isLimitWidth,
  customStyle,
  customTitleStyle,
}: any) => {
  return (
    <View style={[styles.ledgerLine, customStyle]}>
      <Text
        style={[
          styles.titleLedger,
          customTitleStyle,
          isLimitWidth && styles.limitLineWidth,
        ]}
      >
        {title}
      </Text>
      <Text style={styles.labelLedger}>{label}</Text>
    </View>
  );
};

export default LedgerLine;
